import React from 'react';
import { ApolloProvider, gql, useQuery, useMutation } from '@apollo/client';
import client from '../lib/apolloClient';
import SavedSearchesPage from '../components/Succeedo/Marketplace/SavedSearchesPage';

const SAVED_SEARCHES_QUERY = gql`
  query MySavedSearches {
    currentUser { id name succeedo_persona }
    my_saved_searches
  }
`;

const UPDATE_FREQUENCY = gql`
  mutation UpdateSavedSearchFrequency($id: ID!, $alert_frequency: String!) {
    update_saved_search_frequency(id: $id, alert_frequency: $alert_frequency) {
      saved_search
      errors
    }
  }
`;

const DELETE_SAVED_SEARCH = gql`
  mutation DeleteSavedSearch($id: ID!) {
    delete_saved_search(id: $id) {
      ok
      errors
    }
  }
`;

function deriveInitials(name) {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

function Loader() {
  const { data, loading, refetch } = useQuery(SAVED_SEARCHES_QUERY, { fetchPolicy: 'cache-and-network' });

  const [updateFrequency] = useMutation(UPDATE_FREQUENCY, {
    onCompleted: () => refetch(),
  });
  const [deleteSearch] = useMutation(DELETE_SAVED_SEARCH, {
    onCompleted: () => refetch(),
  });

  const user = data?.currentUser;
  const savedSearches = data?.my_saved_searches || [];

  return (
    <SavedSearchesPage
      savedSearches={savedSearches}
      loading={loading}
      persona={(user?.succeedo_persona || 'buyer').toUpperCase()}
      userName={user?.name || ''}
      userInitials={deriveInitials(user?.name)}
      onUpdateFrequency={(id, frequency) => updateFrequency({ variables: { id, alert_frequency: frequency } })}
      onDelete={(id) => deleteSearch({ variables: { id } })}
    />
  );
}

export default function SucceedoSavedSearchesContainer() {
  return (
    <ApolloProvider client={client}>
      <Loader />
    </ApolloProvider>
  );
}
